




































































































































import { Component, Vue } from "vue-property-decorator";
import {
  GET_ANON_AUTH_CPT_CONTEXT,
  GET_CURRENT_USER_ROLE,
  GET_PROPOSALS,
} from "@/store/getters-types";
import { LOGOUT_CURRENT_USER } from "@/store/actions-types";
import { AnonAuthCPTContext } from "@/models/anon/AnonAuthCPTContext";
import NavbarSearchInput from "@/components/search/NavbarSearchInput.vue";
import {
  ALL_USER_AUTHENTICATED_ROLES_EXCEPT_ANON,
  UserRoles,
} from "@/models/auth/AuthenticatedUser";
@Component({
  components: {
    NavbarSearchInput,
  },
})
/**
 * The main navbar on top of the page containing links
 * and auth information
 */
export default class TopNavBar extends Vue {
  /**
   * change the locale key
   * @param languageKey
   */
  public changeLanguage(languageKey: string): void {
    this.$root.$i18n.locale = languageKey;
  }

  /**
   * return the role to the current user
   */
  get currentLoggedInRole(): UserRoles {
    return this.$store.getters[GET_CURRENT_USER_ROLE];
  }

  /**
   * get anon auth cpt context data
   */
  get anonAuthContext(): AnonAuthCPTContext | null {
    return this.$store.getters[GET_ANON_AUTH_CPT_CONTEXT];
  }

  /**
   * check if user can access user management
   */
  get isAdmin(): boolean {
    return this.currentLoggedInRole === UserRoles.ADMIN;
  }

  /**
   * check if a user is authenticated
   */
  get isAuthenticated(): boolean {
    return ALL_USER_AUTHENTICATED_ROLES_EXCEPT_ANON.includes(
      this.currentLoggedInRole
    );
  }

  /**
   * get proposal count from store
   */
  get proposalCount(): number {
    return (this.$store.getters[GET_PROPOSALS].proposals || []).length;
  }

  /**
   * logout the current user
   */
  async logout(): Promise<void> {
    await this.$store.dispatch(LOGOUT_CURRENT_USER);
  }
}
